import React, { useEffect, useState } from "react";
import MyModal from "./MyModal";
import { Button, Col, Row } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../actions/userActions";
import { ROOT_BY_TRADEID_RESET } from "../constants/drugConstants";

const DrugMoveTrade = ({
  show,
  setShow,
  selectedTrade,
  setSelectedTrade,
  selectedTradeRootId,
}) => {
  const [roots, setRoots] = useState([]);
  const [selectedRoot, setSelectedRoot] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const dispatch = useDispatch();
  const getRoots = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.get(
        `/api/drugs/listRoots`,

        config,
      );
      setRoots(data);
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      setError(message);
    }
  };
  const moveTrade = async () => {
    try {
      setLoading(true);

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      const { data } = await axios.put(
        `/api/drugs/${selectedRoot[0]._id}/moveTrade`,
        {
          tradeLabel: selectedTrade.label,
          tradeId: selectedTrade._id,
          oldRootId: selectedTradeRootId,
        },
        config,
      );
      setMessage(data.message);
      setLoading(false);
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      if (message === "Not authorized, token failed") {
        dispatch(logout());
      }
      setError(message);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!show) {
      setSelectedTrade("");
      setMessage("");
    }
  }, [show]);
  return (
    <div>
      <MyModal
        show={show}
        setShow={setShow}
        head={`Move: ${selectedTrade.label}`}
        body={
          <div className="p-2">
            {/* <pre>{JSON.stringify(selectedRoot, null, 2)}</pre>
            <pre>{JSON.stringify(selectedTrade, null, 2)}</pre> */}

            <Row className="mt-3 text-center">
              <Col>MOVE TO</Col>
            </Row>
            <Row>
              {roots.length > 0 ? (
                <Typeahead
                  className="col-12 mt-2"
                  placeholder="Type like: Smoker"
                  options={roots}
                  onChange={(e) => setSelectedRoot(e)}
                  id="rootId"
                />
              ) : (
                <Button onClick={getRoots}>Get Roots</Button>
              )}
            </Row>
            <Row className="text-right mt-2">
              {message && <Col className="text-success">{message}</Col>}
              {message && (
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    window.open(
                      `https://www.cliniceasy.org/drugs?tradeId=${selectedTrade._id}`,
                      "_blank",
                    );
                  }}
                >
                  Show New Port
                </Button>
              )}
              {loading && <Col>Loading...</Col>}
              {error && <Col className="text-danger">{error}</Col>}

              <Col>
                <Button onClick={() => moveTrade()}>Move</Button>
              </Col>
            </Row>
          </div>
        }
      />
    </div>
  );
};

export default DrugMoveTrade;
